import { platform } from '../../types/config'
import {
  DksSlotInfo,
  keyMapItem,
  LayerKeysMap,
  Macro,
  MtSlotInfo,
  TglSlotInfo,
} from '../../types/keyboardKeys'
import { FeatureBase } from '../FeatureBase'

// 扩展功能注册表
declare module '../FeatureMap' {
  export interface DeviceFeatureMap {
    keyboardKeys: IKeyboardKeysFeature
  }
}

export interface IKeyboardKeysFeature {
  // 获取层键映射表
  getLayerKeysMap(isFn?: boolean, platform?: platform): Promise<LayerKeysMap>
  // 获取层键映射表数量
  getLayerKeyCount(isFn?: boolean, platform?: platform): number
  // 流式获取层键映射表
  getLayerKeysMapStream(
    isFn?: boolean,
    batchSize?: number,
    platform?: platform,
  ): AsyncIterable<LayerKeysMap>
  // 设置层键映射表
  setLayerKeysMap(keyItem: keyMapItem, isFn?: boolean, platform?: platform): Promise<void>
  // 获取宏列表
  getMacroList(): Promise<Macro[]>
  // 流式获取宏列表
  getMacroListStream(batchSize?: number): AsyncIterable<Macro[]>
  // 获取指定组的宏
  getMacroByIndex(index: number): Promise<Macro>
  // 设置指定组宏数据
  setMacroByIndex(macro: Macro, index: number): Promise<void>
  // 获取 DKS 高级改键数据区列表（矩阵 0x90 仅存 index）
  getDksList(): Promise<DksSlotInfo[]>
  // 获取指定索引的 DKS 数据
  getDksByIndex(index: number): Promise<DksSlotInfo>
  // 设置指定索引的 DKS 数据
  setDksByIndex(dks: DksSlotInfo, index: number): Promise<void>
  // 获取 MTK 高级改键数据区列表（矩阵 0x92 仅存 index）
  getMtList(): Promise<MtSlotInfo[]>
  // 获取指定索引的 MTK 数据
  getMtByIndex(index: number): Promise<MtSlotInfo>
  // 设置指定索引的 MTK 数据
  setMtByIndex(mt: MtSlotInfo, index: number): Promise<void>
  // 获取 TGL 高级改键数据区列表（矩阵 0x91 仅存 index）
  getTglList(): Promise<TglSlotInfo[]>
  // 获取指定索引的 TGL 数据
  getTglByIndex(index: number): Promise<TglSlotInfo>
  // 设置指定索引的 TGL 数据
  setTglByIndex(tgl: TglSlotInfo, index: number): Promise<void>
}

export class KeyboardKeysFeature extends FeatureBase implements IKeyboardKeysFeature {
  getLayerKeysMap(_isFN?: boolean, _platform?: platform): Promise<LayerKeysMap> {
    return this.unsupported('KeyboardKeysFeature.getLayerKeysMap')
  }
  getLayerKeyCount(_isFN?: boolean, _platform?: platform): number {
    return this.unsupported('KeyboardKeysFeature.getLayerKeyCount')
  }
  getLayerKeysMapStream(
    _isFN?: boolean,
    _batchSize?: number,
    _platform?: platform,
  ): AsyncIterable<LayerKeysMap> {
    return this.unsupported('KeyboardKeysFeature.getLayerKeysMapStream')
  }
  setLayerKeysMap(_keyItem: keyMapItem, _isFN?: boolean, _platform?: platform): Promise<void> {
    return this.unsupported('KeyboardKeysFeature.setLayerKeysMap')
  }
  getMacroList(): Promise<Macro[]> {
    return this.unsupported('KeyboardKeysFeature.getMacroList')
  }
  getMacroListStream(_batchSize?: number): AsyncIterable<Macro[]> {
    return this.unsupported('KeyboardKeysFeature.getMacroListStream')
  }
  getMacroByIndex(_index: number): Promise<Macro> {
    return this.unsupported('KeyboardKeysFeature.getMacroByIndex')
  }
  setMacroByIndex(_macro: Macro, _index: number): Promise<void> {
    return this.unsupported('KeyboardKeysFeature.setMacroByIndex')
  }
  getDksList(): Promise<DksSlotInfo[]> {
    return this.unsupported('KeyboardKeysFeature.getDksList')
  }
  getDksByIndex(_index: number): Promise<DksSlotInfo> {
    return this.unsupported('KeyboardKeysFeature.getDksByIndex')
  }
  setDksByIndex(_dks: DksSlotInfo, _index: number): Promise<void> {
    return this.unsupported('KeyboardKeysFeature.setDksByIndex')
  }
  getMtList(): Promise<MtSlotInfo[]> {
    return this.unsupported('KeyboardKeysFeature.getMtList')
  }
  getMtByIndex(_index: number): Promise<MtSlotInfo> {
    return this.unsupported('KeyboardKeysFeature.getMtByIndex')
  }
  setMtByIndex(_mt: MtSlotInfo, _index: number): Promise<void> {
    return this.unsupported('KeyboardKeysFeature.setMtByIndex')
  }
  getTglList(): Promise<TglSlotInfo[]> {
    return this.unsupported('KeyboardKeysFeature.getTglList')
  }
  getTglByIndex(_index: number): Promise<TglSlotInfo> {
    return this.unsupported('KeyboardKeysFeature.getTglByIndex')
  }
  setTglByIndex(_tgl: TglSlotInfo, _index: number): Promise<void> {
    return this.unsupported('KeyboardKeysFeature.setTglByIndex')
  }
}
